<template>
	<div class="ts-w-full ts-h-full ts-overflow-scroll">
		<label class="required">{{ $t('productRecipe.selectedRecipe') }}</label>
		<div class="ts-mt-3 ts-space-y-1 ts-p-3">
			<p class="ts-bg-blue-500 ts-py-1 ts-px-3 ts-text-white ts-font-hanuman ts-rounded ts-relative"
				v-for="(id, index) in model.sale_code_id_list"
				:key="index"
			>
				{{ getDisplayProductName(id) }}
				<span 
					class="ts-bg-red-500 ts-absolute ts-right-0 ts-mr-2 ts-px-1 ts-cursor-pointer" 
					v-tooltip="$t('delete')"
					@click="removeItem(index)"
				>x</span> 
			</p>
		</div>
	</div>
</template>
<script>
export default {
	props: ['value', 'list'],
	data() {
		return {
			model: {}
		}
	},
	created () {
		this.model = this.value;
	},
	methods: {
		removeItem(index) {
			this.model.sale_code_id_list.splice(index, 1)	
		},
		getDisplayProductName(saleCodeId){
			let product = this.list.find(p => p.pro_sale_code_id == saleCodeId)
			return product.pro_group_name + '-' + product.product_name_en
		},
	},
}
</script>